import { render } from "./UserView.vue?vue&type=template&id=c987deaa"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__